var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStArrowLeft = function SvgStArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#24292D",
    d: "M7.298 3.146a.5.5 0 1 1 .707.708L4.858 7h8.78a.5.5 0 0 1 .491.41l.008.09a.5.5 0 0 1-.5.5H4.858l3.147 3.146a.5.5 0 0 1 .058.638l-.058.07a.5.5 0 0 1-.707 0l-4-4a.509.509 0 0 1-.136-.249.52.52 0 0 1-.01-.105l.005.074a.503.503 0 0 1-.006-.062V7.5a.51.51 0 0 1 .078-.267.483.483 0 0 1 .069-.087l-.045.052a.503.503 0 0 1 .032-.038l.013-.014z"
  })));
};
export default SvgStArrowLeft;